/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useLayoutEffect} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import {getOfferAll} from '../../../../api/modules/offer'
import {
  getProductName,
  getSalesArea,
  getEndUser,
  getSector,
  getIncoterm,
  getProvince,
  getCity,
  getPlant,
  getPayment,
  getProductType,
} from '../../../../api/modules/getdatalist'
import {useNavigate} from 'react-router-dom'
import Country from '../../component/DataCountry.json'
import Pagination from '../../component/Pagination'

import CustomUseEffect from './CustomUseEffect'
import axios from 'axios'
import {getDetailTracking} from '../../../../api/modules/master-data/master_2'
import {getAccessesOffer} from '../../../../api/modules/access/access'
import i18next from 'i18next'
import swal from 'sweetalert'
import {appSelector} from '../../../../redux/slices/appSlices'
import {useAppSelector} from '../../../../redux/hooks'
import {HakAkses} from '../../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import dateformat from 'src/utils/dateformat'

type Props = {
  className: string
}

const TableOffer: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)

  const handleOpen = (e: any) => {
    const icon = e.target
    icon?.classList.toggle('rotate-180')
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const navigate = useNavigate()
  const hakAkses = HakAkses()
  const [showUpload, setShowUpload] = useState(false)
  const [showEdit, setShowEdit] = useState(false)

  const {t} = useTranslation()

  const [order, setOrder] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [allFile, setAllFiles] = useState<any[]>([])

  //#region

  const [test, setTest] = useState({
    sales_org_code: '',
    produsen: {name: ''},
    end_user: '',
    sector: {name: ''},
    incoterm1: {code: ''},
    incoterm2: {code: ''},
    province: {region_name: ''},
    city: {city_name: ''},
    plant_desc: '',
    product_type_desc: '',
    product_name: '',
    product_spec: '',
    request_price: '',
    request_quantum: '',
    notes: '',
    payment_type_1_desc: '',
    payment_type_2_desc: '',
  })
  //#endregion

  const [roleUser, setRoleUser] = useState('')
  const [accesses, setAccesses] = useState<any>()

  useEffect(() => {
    const getOrder = async () => {
      setLoading(true)
      await getOfferAll().then((res) => {
        setOrder(res.data.data.data)
        setLoading(false)
        setNumberURL(res.data.data.links)
      })
    }

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessesOffer(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
    role()
    getOrder()
  }, [])

  const paginateNumber = async (number: any) => {
    setLoading(true)
    const res = await axios.get(`${number}&credentials=${localStorage.getItem('credential')}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
    setOrder(res.data.data.data)
    setLoading(false)
    setNumberURL(res.data.data.links)
  }

  //#endregion

  const [track, setTrack] = useState<any>([])

  const handleTracking = async (id: any) => {
    const res = await getDetailTracking(id)
    setTrack(res.data.data.data[0].statuses)
  }

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <div>
          <p className='mt-5'>
            <i className='fw-normal'>
              {t('Order')}/<span className='text-primary fw-normal'>{t('order-judul')}</span>
            </i>
          </p>
          <h1 className='fw-semibold'>{t('order-judul')}</h1>
        </div>
        {hakAkses?.create && (
          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a user'
          >
            <Link to='/management/order/create' className='btn btn-sm btn-light-primary'>
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              {t('order-tambah')}
            </Link>
          </div>
        )}
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 border-bottom'>
            <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
              <th className='td-order-3 text-center'>{t('order-no')}</th>
              <th className='td-order-2 text-center'>{t('order-tanggal')}</th>
              <th className='td-order-3 text-center'>{t('order-pembeli')}</th>
              <th className='td-order-2 text-center'>{t('order-perihal')}</th>
              <th className='td-order-2 text-center'>Status</th>
              <th className='td-order-3 text-center'>{t('order-aksi')}</th>
            </tr>
          </table>
          {/* End Table Head */}

          {/* Table Content */}

          {/* map data from json */}
          {order.map((item, _index) => (
            <>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 border-bottom'>
                <tr className='d-flex jusify-content-center w-100 align-items-center'>
                  <td className='view td-order-3 d-flex justify-content-center align-items-center'>
                    <button
                      className='iconArow d-flex justify-content-center align-items-center me-2'
                      data-target={'target' + item['po_number']}
                      onClick={handleOpen}
                    >
                      <KTSVG path='/media/icons/duotune/arrows/arrow-down.svg' className='svg-1' />
                    </button>
                    <p>A{item['po_number']}</p>
                  </td>
                  <td className='td-order-2 text-center'>
                    <p className='text-dark fw-semibold d-block fs-7'>
                      {item['created_at'].slice(0, 10)}
                    </p>
                  </td>
                  <td className='td-order-3 text-center'>
                    <span className='text-primary fw-bold d-block fs-6'>
                      {item['customer']?.title} {item['customer']?.name}
                    </span>
                  </td>
                  <td className='td-order-2 text-center'>
                    <span className='d-block '>
                      {item['regarding'] == 'PO001' ? (
                        <span className='badge badge-light-success'>{t('penjualan')}</span>
                      ) : (
                        <span className='badge badge-light-primary'>{t('Non-penjualan')}</span>
                      )}
                    </span>
                  </td>
                  <td className='td-order-2 text-center'>
                    <span className='d-block '>
                      {item['status_text'] == 'Dikirimkan' ? (
                        <span className='badge badge-light-success'>{t('Dikirimkan')}</span>
                      ) : item['status_text'] == 'Ditinjau' ? (
                        <span className='badge badge-light-primary'>{t('Ditinjau')}</span>
                      ) : item['status_text'] == 'Revisi' ? (
                        <span className='badge badge-light-warning'>{t('Revisi')}</span>
                      ) : item['status_text'] == 'Menunggu Negosiasi' ? (
                        <span className='badge badge-light-warning'>{t('Menunggu-Negosiasi')}</span>
                      ) : item['status_text'] == 'Realisasi' ? (
                        <span className='badge badge-light-success'>{t('Realisasi')}</span>
                      ) : item['status_text'] == 'Negosiasi' ? (
                        <span className='badge badge-light-primary'>{t('Negosiasi')}</span>
                      ) : item['status_text'] == 'Negosiasi diterima' ? (
                        <span className='badge badge-light-success'>{t('Negosiasi-Diterima')}</span>
                      ) : item['status_text'] == 'Selesai' ? (
                        <span className='badge badge-light-success'>{t('Selesai')}</span>
                      ) : (
                        <span className='badge badge-light-danger'>{t('Ditolak')}</span>
                      )}
                    </span>
                  </td>
                  <td className='td-order-3'>
                    <div className='d-flex flex-shrink-0 justify-content-center'>
                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title='Detail'
                      >
                        <KTSVG
                          path='/media/icons/duotune/file-text-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>

                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('order-lampiran')}
                      >
                        <KTSVG
                          path='/media/icons/duotune/arrow-down-square-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>
                      <Modal
                        size='lg'
                        show={showUpload}
                        onHide={() => setShowUpload(false)}
                        backdrop='static'
                        keyboard={false}
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('order-fileBox')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Row>
                            <Col sm={6}></Col>
                            <div className='table-responsive mt-4'>
                              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                <thead className='border-bottom'>
                                  <tr className=''>
                                    <th className='text-center'>{t('order-noo')}</th>
                                    {/* <th className='text-center'>{t('order-namaFile')}</th>
                                    <th className='text-center'>{t('order-jenisFile')}</th> */}
                                    <th className='text-center'>{t('order-keterangan')}</th>
                                    <th className='text-center'>{t('order-tglUpload')}</th>
                                    {/* <th className='text-center'>{t('User Code')}</th> */}
                                    <th className='text-center'>{t('order-user')}</th>
                                    <th className='text-center'>{t('order-aksi')}</th>
                                  </tr>
                                </thead>
                                {allFile.map((data: any, _index: number) => (
                                  <tbody key={data?.id ?? _index}>
                                    <tr className=''>
                                      <td className='text-center'>
                                        <label>{_index + 1}</label>
                                      </td>
                                      {/* <td className='text-center'>
                                        <label>{data.name}</label>
                                      </td>
                                      <td className='text-center'>
                                        <label>{t(data.file_type)}</label>
                                      </td> */}
                                      <td className='text-center'>
                                        <label>{data.description}</label>
                                      </td>
                                      <td className='text-center'>
                                        <label>{dateformat(data.updated_at)}</label>
                                      </td>
                                      {/* <td className='text-center'>
                                        <label>
                                          {data.user?.customer_code || data.user?.nama_pengguna}
                                        </label>
                                      </td> */}
                                      <td className='text-center'>
                                        {data.user?.customer != null ? (
                                          <label>{data.user?.customer?.name}</label>
                                        ) : (
                                          <label>{data.user?.name}</label>
                                        )}
                                      </td>
                                      <td className='text-center'>
                                        <button
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          data-bs-toggle='tooltip'
                                          data-bs-placement='top'
                                          data-bs-trigger='hover'
                                          title={t('unduh')}
                                          onClick={() =>
                                            window.open(
                                              data.file_path +
                                                `&token=${localStorage.getItem('token')}`
                                            )
                                          }
                                        >
                                          <KTSVG
                                            path='/media/icons/duotune/arrow-down-square-fill.svg'
                                            className='svg-icon-3'
                                          />
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                ))}
                              </table>
                            </div>
                          </Row>
                        </Modal.Body>
                      </Modal>
                    </div>
                  </td>
                </tr>
              </table>
              <div className='d-flex justify-content-center lefttt'>
                <div className='table-responsive sub-table'>
                  <table className='table'>
                    <tr className='fold' id={'target' + item['po_number']}>
                      <td className='fold-wrapperContent'>
                        <div className='fold-content'>
                          <table className='table-border'>
                            {/* begin::Table head */}
                            <thead>
                              <tr className='fw-bold  border-bottom'>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-item')}
                                </th>
                                {/* <th className='text-center' style={{ padding: '1rem 2.5rem' }}>{t('sub-order-kontrak')}</th> */}
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  Sales Org
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-incoterm')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-jenis')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-produk')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-spek')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-hargaP')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-hargaD')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-kuantum')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-kuantumD')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-wilayah')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-gudang')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('sub-order-jadwalP')}
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  Status
                                </th>
                                <th className='text-center' style={{padding: '1rem 2.5rem'}}>
                                  {t('order-aksi')}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {item['children']?.map((subItem: any, _index: any) => (
                                <tr key={subItem?.id ?? _index}>
                                  <td className='text-center'>{subItem.id}</td>
                                  {/* <td className='text-center'>{subItem.contract_id}</td> */}
                                  <td className='text-center'>{subItem.sales_org_code}</td>
                                  <td className='text-center'>
                                    {subItem.incoterm1?.code}-{subItem.incoterm2?.code}
                                  </td>
                                  <td className='text-center'>{subItem.product_type_desc}</td>
                                  <td className='text-center'>{subItem.product_name}</td>
                                  <td className='text-center'>{subItem.product_spec}</td>
                                  <td className='text-center'>
                                    {i18next.language === 'en'
                                      ? subItem.request_price?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : subItem.request_price?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}
                                  </td>
                                  <td className='text-center'>
                                    {i18next.language === 'en'
                                      ? subItem.fixed_price?.toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : subItem.fixed_price?.toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })}
                                  </td>
                                  <td className='text-center'>{subItem.request_quantum}</td>
                                  <td className='text-center'>{subItem.fixed_quantum}</td>
                                  <td className='text-center'>
                                    {subItem.province?.region_name}, {subItem.city?.city_name}
                                  </td>
                                  <td className='text-center'>{subItem.plant_desc}</td>
                                  <td className='text-center'>
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('Jadwal')}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/calendar-check-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  </td>
                                  <td className='text-center'>
                                    <span className='d-block '>{t(subItem.status_text)}</span>
                                  </td>
                                  <td className='d-flex'>
                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title='Detail'
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/file-text-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>

                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('ubah')}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/pencil-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>

                                    <button
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title='Tracking'
                                      onClick={() => handleTracking(subItem.id)}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/tracking.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            {/* end::Table body */}
                          </table>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </>
          ))}
          {/* Table Content */}
        </div>
        {/* end::Table container */}
      </div>

      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        centered
        scrollable
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Detail Sub Order')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>Sales Org</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.sales_org_code}
                  type='text'
                  placeholder='Sales Org'
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-endUser')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.end_user}
                  type='text'
                  placeholder={t('End_User')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-sektor')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.sector?.name}
                  type='text'
                  placeholder={t('sub-order-sektor')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-incoterm1')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.incoterm1?.code}
                  type='text'
                  placeholder='Incoterm_1'
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-incoterm2')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.incoterm2?.code}
                  type='text'
                  placeholder='Incoterm_2'
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-negara')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control type='text' placeholder={t('sub-order-negara')} disabled />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-provinsi')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  type='text'
                  placeholder={t('sub-order-provinsi')}
                  value={test.province?.region_name}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-kota')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  type='text'
                  placeholder={t('sub-order-kota')}
                  value={test.city?.city_name}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-gudang')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.plant_desc}
                  type='text'
                  placeholder={t('sub-order-gudang')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-jenis')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.product_type_desc}
                  type='text'
                  placeholder={t('sub-order-jenis')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-produk')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.product_name}
                  type='text'
                  placeholder={t('kontrak-nama')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-spek')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.product_spec}
                  type='text'
                  as='textarea'
                  style={{height: '40px'}}
                  placeholder={t('sub-order-spek')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-hargaP')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={
                    i18next.language === 'en'
                      ? test.request_price?.toLocaleString()
                      : test.request_price?.toLocaleString()
                  }
                  type='text'
                  placeholder={t('sub-order-hargaP')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-kuantum')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.request_quantum}
                  type='text'
                  placeholder={t('kontrak-kuantum')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-catatan')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.notes}
                  type='text'
                  as='textarea'
                  style={{height: '40px'}}
                  placeholder={t('sub-order-catatan')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-3'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-payment1')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.payment_type_1_desc}
                  type='text'
                  placeholder={t('sub-order-payment1')}
                  disabled
                />
              </td>
            </tr>
          </table>
          <table className='mb-5'>
            <tr>
              <td style={{width: '135px'}}>
                <h6>{t('sub-order-payment2')}</h6>
              </td>
              <td className='w-50'>
                <Form.Control
                  value={test.payment_type_2_desc}
                  type='text'
                  placeholder={t('sub-order-payment2')}
                  disabled
                />
              </td>
            </tr>
          </table>
        </Modal.Body>
      </Modal>

      <div className='my-5'>
        <Pagination paginate={paginateNumber} test={numberURL} />
      </div>
    </div>
  )
}

export {TableOffer}
